import { FC } from 'react';

import { MFEPage } from './mfe-page';
import './app.css';
import { FeBundleStore } from './common/stores/fe-bundle.store';
import { FeBundleApi } from './common/api/fe-bundle.api';
import { provide } from '@servicetitan/react-ioc';
import axios from 'axios';

/*
 * This is sufficient and expected for Duende's BFF CSRF implementation.
 * https://duendesoftware.com/blog/20250325-understanding-antiforgery-in-aspnetcore#anti-forgery-tokens-and-duende-backend-for-frontend-bff
 */
axios.defaults.headers.common['X-CSRF'] = '1';

export const App: FC = provide({
    singletons: [FeBundleApi, FeBundleStore],
})(() => <MFEPage />);
